import alpine from 'alpinejs'
import persist from '@alpinejs/persist'

import primaryMenu from './components/primary-menu'

import.meta.glob(['../images/**', '../fonts/**'])

alpine.data('primaryMenu', primaryMenu)

alpine.plugin(persist)

Object.assign(window, { Alpine: alpine }).Alpine.start()

document.addEventListener('DOMContentLoaded', () => {
	if (typeof window.html_forms === 'undefined' || typeof window.dataLayer === 'undefined') {
		return
	}

	window.html_forms.on('success', (form) => {
		window.dataLayer.push({
			event: 'form_submission',
			form_name: form.dataset.slug || form.dataset.title || '',
		})
	})
})
